import { defineMessages } from 'react-intl'

const messages = defineMessages({
  selectOffer: {
    id: 'global.select-offer-modify-dates',
  },
  newSearch: {
    id: 'global.your-new-search',
  },
  totalCostForChange: {
    id: 'global.total-cost-change',
  },
})

export default messages
